import { UNAUTHORIZED_POPUP_SHOW } from "./UnauthorizedPopupActionTypes";

export const showUnauthorizedPopupAction =
  (message: string) => (dispatch: any) => {
    dispatch({
      type: UNAUTHORIZED_POPUP_SHOW,
      payload: { message },
    });
  };
